var _ = require('underscore');
var $ = require('jquery');
var Backbone = require('backbone');
var Backgrid = require('backgrid');
var Marionette = require('marionette');
var Behaviors = require('Behaviors');
var Entities = require('Entities');
var Grid = require('Grid');
var Validation = require('validation');
var Azure = EY.Consultation.Lookups.Azure;
var Labels = EY.Consultation.Labels;
var ALTERNATIVE_FRONTEND_IDENTITY = EY.Consultation.Lookups.Configuration.ALTERNATIVE_FRONTEND_IDENTITY;

var Action = Marionette.View.extend({
    className: 'string-cell sortable renderable displayName',
    events: {
        'click @ui.name': 'select'
    },
    tagName: 'td',
    template: '#picklistAction',
    ui: {
        name: '#name'
    },
    select: function (e) {
        e.preventDefault();
        this.model.collection.any(function (model) {
            return model.get('selected') && model.set('selected', false);
        });
        this.model.set('selected', true);
    }
});

var Specialty = Marionette.View.extend({
    behaviors: [Behaviors.TooltipGrid],
    className: 'string-cell sortable renderable tooltip-css',
    tagName: 'td',
    template: _.noop,
    onRender: function () {
        this.$el.html(_.first(this.model.get('roles')).specialty);
    }
});

var picklistColumns = function () {
    return [{name: 'displayName', label: Labels.Name, editable: false, cell: Action},
        {name: 'email', label: Labels.Email, editable: false, cell: 'string'},
        {name: 'specialty', label: Labels.Specialty, editable: false, cell: Specialty},
        {name: 'physicalDeliveryOfficeName', label: Labels.Office, editable: false, cell: 'string'}];
};

var graphColumns = function () {
    return [{name: 'displayName', label: Labels.Name, editable: false, cell: Action},
        {name: 'country', label: Labels.Country, editable: false, cell: 'string'},
        {name: 'city', label: Labels.City, editable: false, cell: 'string'},
        {name: 'mail', label: Labels.Email, editable: false, cell: 'string'}];
};

var GraphUsers = Backbone.Collection.extend({
    model: Entities.User,
    comparator: 'displayName',
    parse: function (response) {
        return response.value;
    },
    sync: function (method, model, options) {
        options = options || {};
        options.headers = {
            'ConsistencyLevel': 'eventual'
        };
        return Backbone.sync.apply(this, arguments);
    }
});

var PickListGrid = Marionette.View.extend({
    events: {
        'keyup @ui.user': _.debounce(function (e) {
            this.search(e);
        }, 500),
        'hidden.bs.dropdown': 'render',
        'hide.bs.dropdown': 'removeTooltip',
        'shown.bs.dropdown': 'scrollIntoView',
        'show.bs.dropdown': 'showLookup'
    },
    collectionEvents: {
        'change:selected': 'select',
        'sync': 'sync',
        'reset': 'toggleEmptyMessage'
    },
    initialize: function () {
        Validation.bind(this);
    },
    regions: {
        grid: '#picklistGrid'
    },
    template: '#picklistLayout',
    ui: {
        user: '#user',
        picklist: '#picklistGrid',
        lookup: '.user-lookup',
        emptyMessage: '#emptyMessage'
    },
    onRender: function () {
        Grid.show({
            collection: this.collection,
            columns: this.options.columns,
            region: this.getRegion('grid')
        });
    },
    toggleEmptyMessage: function () {
        if (this.collection.length === 0) {
            this.ui.emptyMessage.show();
            this.ui.picklist.hide();
        } else {
            this.ui.emptyMessage.hide();
            this.ui.picklist.show();
        }
    },
    removeTooltip: function () {
        var tooltipId = this.$el.find('td.specialty[aria-describedby]').attr('aria-describedby');
        if (tooltipId) {
            $('#' + tooltipId).remove();
        }
    },
    select: function (user) {
        if (user.get('selected')) {
            var gpn = user.get('mailNickname') ? user.get('mailNickname') : user.get('gpn');
            this.model.set({
                displayName: user.get('displayName'),
                email: user.get(ALTERNATIVE_FRONTEND_IDENTITY) || user.get('mail') || user.get('email'),
                givenName: (user.get('givenName') + ' ' + (user.has('surname') ? user.get('surname') : '')).trim(),
                physicalDeliveryOfficeName: user.get('physicalDeliveryOfficeName'),
                upn: user.get('upn').toLowerCase(),
                gpn: gpn
            });
            this.ui.user.val(this.model.get('givenName'));
            this.collection.reset();
        }
    },
    search: function () {
        var context = this;
        var name = new RegExp(this.ui.user.val().trim(), 'i');
        var options = this.fullCollection.filter(function (user) {
            return name.test(user.get('displayName') || name.test(user.get('email')));
        });

        if (!name.length) {
            context.reset();
        }
        this.collection.reset(options);
        if (!context.ui.user.parent().hasClass('open')) {
            context.ui.lookup.dropdown('toggle');
        }
    },
    sync: function (collection) {
        this.fullCollection = collection.clone();
    },
    reset: function () {
        this.model.set({
            displayName: '',
            email: '',
            givenName: '',
            physicalDeliveryOfficeName: '',
            upn: '',
            gpn:''
        });
        this.collection.reset();
    },
    scrollIntoView: function () {
        if (!this.ui.lookup.isInViewport()) {
            this.ui.lookup.get(0).scrollIntoView(false);
            $('html').scrollLeft(0);
            $('.record-scroll').scrollLeft(0);
        }
    },
    showLookup: function (e) {
        if (!this.collection.length) {
            e.preventDefault();
        }
    }
});

var LookupGrid = PickListGrid.extend({
    search: function (e) {
        var context = this;
        var name = this.ui.user.val().trim().replace(/'/g, "''");
        if (e.keyCode && name.length && name.length >= EY.Consultation.Lookups.Configuration.UserLookupInputLength) {
            var mail = name.replace(' ', '.');
            var FilterUserByCountry = '';
            var userDetails = 
                '_id,active,adStatus,displayName,preferences,geography,givenName,email,' +
                'physicalDeliveryOfficeName,roles,upn,gpn,country,city,mail,userPrincipalName,mailNickname,surname,userType,' + ALTERNATIVE_FRONTEND_IDENTITY;
            if (EY.Consultation.Lookups.Configuration.FilterUserLookupCountry != '') {
                _.each(EY.Consultation.Lookups.Configuration.FilterUserLookupCountry.split('|'), function (country) {
                    FilterUserByCountry = FilterUserByCountry + "startswith(country,'"+ country +"') or ";
                });
                FilterUserByCountry = "(" + FilterUserByCountry.substr(0, FilterUserByCountry.lastIndexOf(' or ')) + ") and (";
                this.collection.url = encodeURI(
                    Azure.GraphUrl + 
                    "users?$select=" + userDetails + "&$top=10&$filter=" + FilterUserByCountry + 
                    "startswith(displayName,'" + name + 
                    "') or startswith(givenName,'" + name + 
                    "') or startswith(surname, '" + name + 
                    "') or startswith(" + ALTERNATIVE_FRONTEND_IDENTITY + ", '" + name + 
                    "') or startswith(" + ALTERNATIVE_FRONTEND_IDENTITY + ", '" + mail + 
                    "') or startswith(mail, '" + name + 
                    "') or startswith(mail, '" + mail + "'))");
            } else {
                this.collection.url = encodeURI(
                    Azure.GraphUrl +
                    "users?$select=" + userDetails + "&$top=50&$filter=(startswith(displayName,'" + name +
                    "') or startswith(givenName,'" + name +
                    "') or startswith(surname, '" + name +
                    "') or startswith(" + ALTERNATIVE_FRONTEND_IDENTITY + ", '" + name +
                    "') or startswith(" + ALTERNATIVE_FRONTEND_IDENTITY + ", '" + mail +
                    "') or startswith(mail, '" + name +
                    "') or startswith(mail, '" + mail + "'))and (userType ne 'Guest')&$count=true");
            }
            this.collection.fetch().done(function () {
                var options = _.chain(context.collection.models).reject(function (user) {
                    //Since K8S doesn't allow booleans but strings I've decided to check string representation for RestrictExternalUsers
                    return !user.get(ALTERNATIVE_FRONTEND_IDENTITY) || (Azure.RestrictExternalUsers == "true" && !!Azure.RestrictExternalCriteria && context.isExternalUser(user));
                })
                    .each(function (user) {
                        user.set('upn', user.get(ALTERNATIVE_FRONTEND_IDENTITY).replace(/'/g, "`"));
                    }).value();
                context.collection.reset(options);
                context.ui.picklist.removeClass('hidden').animate({ scrollTop: 0 }, 0);
                if (!context.ui.user.parent().hasClass('open')) {
                    context.ui.lookup.dropdown('toggle');
                }
            });
        } else if (!name.length) {
            context.reset();
        }
    },
    isExternalUser: function (user) {

        var result = false;
        var keyValuePairs = Azure.RestrictExternalCriteria.split(',');
        _.each(keyValuePairs, function (pair) {

            var key = pair.split(':')[0].trim();
            var value = pair.split(':')[1].trim();

            result = result || !!user.get(key).match(new RegExp(value, 'i'));
        });

        return result;
    }
});

// Expects a model with id, givenName and upn attributes.
module.exports.show = function (options) {
    var region = options.region;
    var user = options.user;
    var collection = options.collection;

    user.set('id', user.id || _.now());
    region.show(collection ? new PickListGrid(_.extend({}, options, {
        collection: collection,
        columns: picklistColumns(),
        model: user
    })) : new LookupGrid(_.extend({}, options, {
        collection: new GraphUsers(),
        columns: graphColumns(),
        model: user
    })));
};


// WEBPACK FOOTER //
// ./js/Modules/User/UserLookup.js